export default "What did you notice about this graph?\n"